@if ((isLoading$ | async)) {
  @if (families$ | async; as category) {
    @if (category.code) {
      <div class="container">
        <cx-breadcrumb>
          <nav>
            <ol>
              <li>
                <a href="/es/">Home</a>
              </li>
            </ol>
          </nav>
          <span class="breadcrumb-h1">{{ category.name }}</span>
          <!--  <button class="custom-button-switch go-back" (click)="back()">-->
          <!--    <app-custom-icons [type]="iconTypes.ARROW_DOWN_ICON"></app-custom-icons>-->
        <!--  </button>-->
      </cx-breadcrumb>
      <h1 class="h2-component">{{category.name}}</h1>
      <div class="family-text" [innerHTML]="category?.familyText"></div>
      <div class="families">
        @for (family of category.families; track family; let i = $index) {
          <a class="family" [routerLink]="family.query.url">
            <cx-media [container]="family.image"></cx-media>
            <h2 class="h3-component">{{family.name}}</h2>
          </a>
        }
      </div>
      <div class="col-md-6 offset-md-3 col-lg-4 offset-lg-4 show-all-btn ">
        @if (code && category.families) {
          <cx-generic-link
            [url]="{ cxRoute: 'category', params: { code: code, name: sanitizedCategory(category.name) } } | cxUrl"
            [class]="btnClass">
            {{ 'productList.showAll' | cxTranslate }}
          </cx-generic-link>
        }
      </div>
    </div>
  } @else {
    {{ setTitleNotFoundPage() }}
    <cx-breadcrumb>
      <nav>
        <ol>
          <li>
            <a href="/es/">Home</a>
          </li>
        </ol>
      </nav>
      <span class="breadcrumb-h1">{{ 'common.notFound' | cxTranslate}}</span>
    </cx-breadcrumb>
    <div class="ErrorPageTemplate">
      <div class="MiddleContent">
        <ng-container [cxComponentWrapper]="{
          flexType: 'OhgarCategoryBlocksComponent',
          typeCode: 'OhgarCategoryBlocksComponent',
          uid: 'ErrorPageBlocksCategoryComponent'
        }">
        </ng-container>
        <ng-container [cxComponentWrapper]="{
          flexType: 'OhgarCategoryBlocksComponent',
          typeCode: 'OhgarCategoryBlocksComponent',
          uid: 'ErrorPageLinksComponent'
        }">
        </ng-container>
      </div>
    </div>
  }
}
} @else {
  <div class="cx-spinner">
    <cx-spinner></cx-spinner>
  </div>
}
